module.exports = __webpack_public_path__ + "img/view_halo.1ddb21b4.png";